import React from 'react';
import {StyleSheet, View, Text, Image, ImageSourcePropType} from 'react-native';
import {colors} from 'src/assets';
import {Icon} from 'src/components';
import {UserStatus} from 'src/domains';
import LocalText from 'src/local';

type Props = {
  source?: ImageSourcePropType;
  status?: UserStatus;
};

export const OfferAvatar: React.FC<Props> = ({source, status}) => {
  return (
    <View style={styles.container}>
      {source ? (
        <Image style={[styles.image]} source={source} />
      ) : (
        <View style={[styles.imageEmpty]}>
          <Icon name={'person'} color={colors.chokuGray5} size={32} />
        </View>
      )}
      {status === UserStatus.LOGOUT && (
        <View style={[styles.textContainer, styles.logoutTextContainer]}>
          <Text style={styles.text}>
            {LocalText.components.offerListItem.offerAvatar.userStatusLogout}
          </Text>
        </View>
      )}
      {status === UserStatus.OFFERABLE && (
        <View style={[styles.textContainer, styles.offerableTextContainer]}>
          <Text style={styles.text}>
            {LocalText.components.offerListItem.offerAvatar.userStatusOfferable}
          </Text>
        </View>
      )}
      {status === UserStatus.ACTIVE && (
        <View style={[styles.textContainer, styles.activeTextContainer]}>
          <Text style={styles.text}>
            {LocalText.components.offerListItem.offerAvatar.userStatusActive}
          </Text>
        </View>
      )}
      {status === UserStatus.IN_CALL && (
        <View style={[styles.textContainer, styles.inCallTextContainer]}>
          <Text style={styles.text}>
            {LocalText.components.offerListItem.offerAvatar.userStatusInCall}
          </Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  image: {
    width: 136,
    height: 136,
    borderRadius: 12,
  },
  imageEmpty: {
    backgroundColor: colors.chokuGray7,
    width: 136,
    height: 136,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 2,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    minHeight: 16,
  },
  logoutTextContainer: {
    backgroundColor: colors.chokuGray6,
  },
  offerableTextContainer: {
    backgroundColor: colors.chokuGreen,
  },
  activeTextContainer: {
    backgroundColor: colors.orange,
  },
  inCallTextContainer: {
    backgroundColor: colors.chokuRed,
  },
  text: {
    fontSize: 9,
    fontWeight: 'bold',
    color: colors.white,
  },
});
